import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    sidebarCollapsed: false,
    isChatOpen: true,
    navBarMobileVisible: false,
    data: {
      constants: { NEW_STARTUPS_AGE_IN_DAYS: 7 },
    },
    appInfo: {
      version: null,
      apiVersion: null,
      versionHasChanged: false,
    },
  },
  mutations: {
    COLLAPSE_SIDEBAR(state) {
      state.sidebarCollapsed = true
    },
    EXTEND_SIDEBAR(state) {
      state.sidebarCollapsed = false
    },
    SHOW_CHAT_MESSAGE(state) {
      state.isChatOpen = true
    },
    HIDE_CHAT_MESSAGE(state) {
      state.isChatOpen = false
    },
    TOGGLE_NAV_BAR_MOBILE(state) {
      state.navBarMobileVisible = !state.navBarMobileVisible
    },

    setData(state, data) {
      state.data = data
    },

    setVersion(state, version) {
      if (!version) {
        return
      }
      if (state.appInfo.version && state.appInfo.version !== version) {
        state.appInfo.versionHasChanged = true
      }
      state.appInfo.version = version
    },
    setApiVersion(state, apiVersion) {
      if (!apiVersion) {
        return
      }
      if (state.appInfo.apiVersion && state.appInfo.apiVersion !== apiVersion) {
        state.appInfo.versionHasChanged = true
      }
      state.appInfo.apiVersion = apiVersion
    },
    markNewVersionAsSeen(state) {
      state.appInfo.versionHasChanged = false
    },
  },

  actions: {
    async fetch({ commit }) {
      const response = await http.get('/commons/all-data')
      commit('setData', response.data)
      return response.data
    },
  },
}
